module.exports = {
    toTargetPayload,
    withTargets
};

function toTargetPayload({ id, targetType, targetValue, combinationType }) {

    const target = {
        targetType,
        targetValue,
        combinationType
    };

    if (Number.isInteger(id)) {
        target.id = id;
    }

    return target;
}

function withTargets(payload, targets) {

    return {
        ...payload,
        targets: (targets || []).map(toTargetPayload)
    };
}
